export default __webpack_public_path__ + "static/media/fog-day.8e2b7f59.svg";